import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { Link, NavLink } from 'react-router-dom';
import { Switch, Route, Redirect, withRouter } from 'react-router';
import Loadable from 'react-loadable';

import Frontpage from './Frontpage';
import Teams from './Teams';

export const API_ROOT = 'https://hackapi.longhash.com/';
export const serialize = data =>
  Object.keys(data)
    .map(function(k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
    })
    .join('&');
export const REQUEST_HEADER = {
  method: 'POST',
  mode: 'cors',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
};
export const validateEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const Hline = ({ label, title, nodot, getRef, ...rest }) => (
  <h2 {...rest} ref={ref => getRef && getRef(ref)}>
    <b
      className={classnames({
        nodot
      })}
    >
      {' '}
      {label}{' '}
    </b>{' '}
    <span className="title"> {title} </span>{' '}
  </h2>
);

export const scrollTo = function(to, duration) {
  const element = document.scrollingElement || document.documentElement,
    start = element.scrollTop,
    change = to - start,
    startDate = +new Date(),
    easeInOutQuad = function(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    },
    animateScroll = function() {
      const currentDate = +new Date();
      const currentTime = currentDate - startDate;
      element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        element.scrollTop = to;
      }
    };
  animateScroll();
};

export const Logo = ({ height = 24, ...rest }) => <img {...rest} height={height} src={require('./assets/logo-white.png')} />;

const Loading = () => <div className="loading"> Loading... </div>;

const News = Loadable.Map({
  loading: Loading,
  loader: {
    Component: () => import('./News'),
    data: () => new Promise(res => res(require('./news.json')))
  },
  render(loaded, props) {
    let Component = loaded.Component.default;
    let data = loaded.data;
    return <Component {...props} data={data} />;
  }
});

class App extends Component {
  state = {
    showNav: false,
    mounted: false
  };
  componentDidMount() {
    this.setState({
      mounted: true
    });
  }
  render() {
    const { showNav, mounted } = this.state;
    if (mounted === false) return <div className="App">Loading...</div>;

    return (
      <div className="App">
        <header>
          <div className="cont">
            <Link to="/" className="logo" />
            <nav
              className={classnames(
                {
                  ['d-none']: !showNav
                },
                'd-lg-block'
              )}
            >
              <NavLink
                to="/"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
                exact
              >
                {' '}
                HOME{' '}
              </NavLink>{' '}
              <NavLink
                to="/vision"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
              >
                {' '}
                VISION{' '}
              </NavLink>{' '}
              <NavLink
                to="/portfolio"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
              >
                {' '}
                PORTFOLIO{' '}
              </NavLink>{' '}
              <NavLink
                to="/about"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
              >
                {' '}
                ABOUT{' '}
              </NavLink>{' '}
              <NavLink
                to="/teams"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
              >
                {' '}
                TEAM{' '}
              </NavLink>{' '}
              <NavLink
                to="/news/1"
                onClick={() =>
                  this.setState({
                    showNav: false
                  })
                }
                activeClassName="selected"
              >
                {' '}
                NEWS{' '}
              </NavLink>{' '}
            </nav>{' '}
            <div
              className={classnames('menubtn d-lg-none', {
                open: showNav
              })}
              onClick={() =>
                this.setState({
                  showNav: !showNav
                })
              }
            />{' '}
          </div>{' '}
        </header>
        <Switch>
          <Route path="/news/:id" exact component={News} />
          <Route path="/teams" exact component={Teams} />{' '}
          <Route path="/" component={Frontpage} />{' '}
        </Switch>
        <footer>
          <Hline label="contact" title="us" lang="联系我们" />
          <p>
            <span className="px-2"> contact @gf.network </span> {' '}
          </p>{' '}
          <div className="copyright"> Copyright© 2018 gf.network </div>{' '}
        </footer>{' '}
      </div>
    );
  }
}

export default withRouter(App);

// WEBPACK FOOTER //
// ./src/App.js
